<template>
  <div id="leave-message">
    <div class="leave-message">
      <div class="left">
        <div class="title">
          <p class="line"></p>
          <p>预约电话 400-808-9629</p>
        </div>
        <div class="title">
          <p class="line"></p>
          <p>联系客服 （关注公众号联系客服）</p>
        </div>
        <div class="input">
          <el-input
            style="margin: 10px 0;"
            v-model="name"
            placeholder="请输入您的姓名"
          ></el-input>
          <el-input
            style="margin: 10px 0;"
            v-model="phone"
            placeholder="请输入您的手机号"
          ></el-input>
          <el-input
            style="margin: 10px 0;"
            type="textarea"
            :rows="3"
            placeholder="输入您的备注需求"
            v-model="content"
          >
          </el-input>
          <el-button
            @click="handleSubmitClick"
            style="margin-top: 10px"
            type="primary"
            >提交</el-button
          >
        </div>
      </div>
      <div class="right">
        <img src="../../assets/images/message.png" alt="" />
      </div>
    </div>
    <el-button @click="goBack" class="go-back" type="primary">{{
      this.$t("lang.top")
    }}</el-button>
  </div>
</template>

<script>
export default {
  name: "LeaveMessage", // 留言
  components: {},
  data() {
    return {
      name: "",
      phone: "",
      content: ""
    };
  },
  methods: {
    goBack() {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    },
    handleSubmitClick() {
      let that = this;
      if (that.name === "") {
        this.$message({
          message: "请输入姓名",
          type: "warning"
        });
      } else if (that.lostFocus()) {
        return false;
      } else {
        that
          .$confirm("确认提交", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
          .then(() => {
            that.$http
              .post(
                "http://api.chunhuahealth.com/api/official_website/backlog_add",
                {
                  name: that.name,
                  mobile: that.phone,
                  comment: that.content
                }
              )
              .then(res => {
                if (res.status === 200 && res.data.code === "20000") {
                  that.name = "";
                  that.phone = "";
                  that.content = "";
                  that.$message({
                    type: "success",
                    message: "提交成功!"
                  });
                } else {
                  that.$message.error("提交失败！请重试");
                }
              })
              .catch(err => {
                if (err) {
                  that.$message.error("服务器错误！请稍后重试");
                }
              });
          });
      }
    },
    // 失去焦点事件
    lostFocus() {
      const TEL_REGEXP = /^1([38]\d|5[0-35-9]|7[3678])\d{8}$/;
      if (!TEL_REGEXP.test(this.phone)) {
        this.$message({
          message: "请输入正确的手机号",
          type: "warning"
        });
        return true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#leave-message {
  width: 75%;
  min-width: 960px;
  overflow: hidden;
  height: 414px;
  margin: 0 auto 20px;
  box-shadow: 0 6px 22px 2px rgba(197, 229, 255, 0.18);
  background: #ffffff;
  .leave-message {
    overflow: hidden;
    display: flex;
    height: 100%;
    .left {
      flex: 1;
      height: 100%;
      margin: 40px 30px;
      .title {
        font-size: 24px;
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        color: #6e6e6e;
        .line {
          display: inline-block;
          height: 26px;
          width: 6px;
          background: #3496e3;
          margin-right: 5px;
        }
      }
    }
    .right {
      flex: 1;
      height: 100%;
      margin: 40px 30px;
      img {
        width: 100%;
      }
    }
  }
  .el-button {
    width: 100px;
    /*margin: 0 auto;*/
    /*margin-bottom: 30px;*/
  }
  .el-input {
    background: #eeeeee;
  }
  .el-input__inner {
    background: #eeeeee;
  }
}
</style>
